import _ from "lodash";
import React from "react";
import cx from "classnames";

export function ReduxTripleSwitch({ input }) {
  return (
    <div className="btn-group btn-group-sm">
      <button
        type="button"
        onClick={() => input.onChange(true)}
        className={cx("btn btn-default", {
          "btn-primary": _.isBoolean(input.value) && input.value,
        })}
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => input.onChange(false)}
        className={cx("btn btn-default", {
          "btn-primary": input.value !== "" && _.isBoolean(input.value) && !input.value,
        })}
      >
        No
      </button>
      <button
        type="button"
        onClick={() => input.onChange("")}
        className={cx("btn btn-default", { "btn-primary": input.value === "" })}
      >
        Unknown
      </button>
    </div>
  );
}
